import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";

import { UserStore } from "../../../../stores/UserStore/UserStore";
import {
  NoStation,
  NoLaundryTypes,
  LaundryTypesContainer,
} from "./ChooseLaundryTypeStyles";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { Colors } from "../../../../constants/Colors";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";
import { LaundryStore, setFinalPrice, setPage, setSelectedLaundryType } from "../../../../stores/LaundryStore/LaundryStore";
import { LaundryTypeOption } from "../../../../types/laundry.types";
import { fetchLaundryTypesEffect } from "../../../../stores/LaundryStore/LaundryStore.effects";

interface BtnsProps {
  selected?: LaundryTypeOption;
  handleGoBack: () => void;
}

const Buttons = ({ handleGoBack }: BtnsProps) => {
  return (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
    </>
  );
};

const ChooseLaundryType: React.FC = () => {
  const { laundryTypeOptions, selectedLaundryType } = useUnit(LaundryStore);
  const { station } = useUnit(UserStore);

  useEffect(() => {
    handleGetWashings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetWashings = () => {
    if (!station) {
      return;
    }

    setLoading(true);

    fetchLaundryTypesEffect(station).finally(() => {
      setLoading(false);
    });
  };

  const handleNextStep = () => {
    setPage(PAGES.CHOOSE_LAUNDRY_MACHINE);
  };

  const handleGoBack = () => {
    setPage(PAGES.START_PAGE);
  };

  const renderSection = (title: string, laundryTypes: LaundryTypeOption[]) => {
    if (!laundryTypes.length) return null;

    return (
      <div style={{ marginBottom: "3rem" }}>
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "1.5rem",
            textAlign: "center",
            color: Colors.commons.black,
          }}
        >
          {title}
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "1.5rem",
          }}
        >
          {laundryTypes.map((laundryType) => {
            //const isselected = selectedLaundryType?.id === laundryType.id;
            const fixedPrice = laundryType?.price?.toFixed(2).replace(".", ",");
            const priceText = `R$ ${fixedPrice ?? "ERRO"}`;

            return (
              <TotemOption
                key={laundryType.id}
                title={laundryType?.name}
                subtitle={priceText}
                isselected={false}
                //isselected={isselected}
                execSelection={() => { 
                  setSelectedLaundryType(laundryType);
                  setFinalPrice(laundryType.price);
                  handleNextStep();
                }}
              />
            );
          })}
        </div>
      </div>
    );
  };

  const renderWashings = () => {
    if (!station) {
      return (
        <NoStation>
          <p>Usuário sem estação, procure um atendente!</p>
        </NoStation>
      );
    }

    if (!laundryTypeOptions?.length)
      return (
        <NoLaundryTypes onClick={handleGetWashings}>
          <p>Nenhum tipo de lavanderia encontrado.</p>
          <p>Clique aqui para tentar novamente</p>
          <p> ou solicite ajuda a um atendente</p>
        </NoLaundryTypes>
      );

    // separando em seções
    const wash = laundryTypeOptions.filter((w) => w.type.includes("L"));
    const dry = laundryTypeOptions.filter((w) => w.type.includes("S"));

    return (
      <>
        {renderSection("Lavar", wash)}
        {renderSection("Secar", dry)}
      </>
    );
  };

  return (
    <TotemSkeleton
      title="Escolha uma Opção"
      buttons={
        <Buttons
          handleGoBack={handleGoBack}
        />
      }
    >
      <LaundryTypesContainer>{renderWashings()}</LaundryTypesContainer>
    </TotemSkeleton>
  );
};

export default ChooseLaundryType;
